import {
  GET_EXTERNAL_PROJECTS_COUNTRIES_LOADING,
  GET_EXTERNAL_PROJECTS_COUNTRIES_SUCCESS,
  GET_EXTERNAL_PROJECTS_COUNTRIES_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getCountriesExternalProjectsUrl } from "api/apiUrls";

export const getExternalProjectsCountriesActions =
  (data?: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_COUNTRIES_LOADING,
        payload: true,
      });

      const response: any = await listItemsService(
        `${getCountriesExternalProjectsUrl}`,
        ``
      );

      dispatch({
        type: GET_EXTERNAL_PROJECTS_COUNTRIES_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({ type: GET_EXTERNAL_PROJECTS_COUNTRIES_FAILURE, payload: err });
    } finally {
      dispatch({
        type: GET_EXTERNAL_PROJECTS_COUNTRIES_LOADING,
        payload: false,
      });
    }
  };
